import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import NotFound from "../NotFound";
import { getBlogPostBySlug } from "./data";

const BlogDetailPage = () => {
  useScrollAnimation();
  const { slug = "" } = useParams();
  const post = getBlogPostBySlug(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) return <NotFound />;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main>
        <section className="relative pt-32 pb-16 bg-[#0D0D0D] overflow-hidden">
          <div className="absolute inset-0 opacity-15">
            <img
              src="/images/menu-icin-cephe-44a1019c.png"
              alt={post.title}
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="absolute top-0 left-0 w-1.5 h-full bg-[#E6A800]" />
          <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-10">
            <div className="flex items-center gap-2 mb-8">
              <Link to="/" className="text-white/40 text-xs font-head hover:text-[#E6A800] tr uppercase tracking-wider">
                Ana Sayfa
              </Link>
              <i className="ri-arrow-right-s-line text-white/30 text-xs" />
              <Link to="/blog" className="text-white/40 text-xs font-head hover:text-[#E6A800] tr uppercase tracking-wider">
                Blog
              </Link>
              <i className="ri-arrow-right-s-line text-white/30 text-xs" />
              <span className="text-[#E6A800] text-xs font-head uppercase tracking-wider">Yazı</span>
            </div>

            <p className="text-[#E6A800] font-head font-700 uppercase tracking-[0.22em] mb-3">Blog Yazısı</p>
            <h1 className="text-white font-head font-black text-4xl md:text-6xl leading-tight">
              {post.title}
            </h1>
            <p className="mt-4 text-white/55 text-base">
              {post.date} · {post.readTime} okuma
            </p>
          </div>
        </section>

        <article className="pb-24 px-6 lg:px-10">
          <div className="max-w-4xl mx-auto">
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 text-[#9E9E9E] hover:text-[#E6A800] transition-colors my-8"
            >
              <i className="ri-arrow-left-line" />
              Blog'a Dön
            </Link>

            <img
              src={post.coverImg}
              alt={post.title}
              className="w-full h-[300px] md:h-[420px] object-cover border border-[#EFEFEF]"
            />

            <div className="mt-10 space-y-6">
              {post.content.map((paragraph, index) => (
                <p key={index} className="text-[#2F2F2F] text-lg leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
};

export default BlogDetailPage;
